import { Button, Dropdown } from "antd";
import { CaretDownOutlined } from "@ant-design/icons";
export default function TemplateSelector({
  onApply,
  templateList,
  style = {},
}) {
  return (
    <Dropdown
      menu={{
        items: templateList,
        onClick: onApply,
      }}
    >
      <Button className="statusButton" type="text" style={style}>
        Apply Template
        <CaretDownOutlined />
      </Button>
    </Dropdown>
  );
}
